import { Modal } from '../../../../ReactSharedScripts/components/ModalBox';

export const ModalBox = Modal;
